import React, { useEffect, useState } from "react";
import { Navbar, Nav, Container, Dropdown, Image } from 'react-bootstrap';

import api from "../api";
import { faProjectDiagram } from "@fortawesome/free-solid-svg-icons/faProjectDiagram";
import { useParams, useLocation } from "react-router-dom";
import SocialMedia from "./SocialMedia";
import Modal from "./Modal";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faShareNodes } from "@fortawesome/free-solid-svg-icons/faShareNodes";
import { faCopy } from "@fortawesome/free-solid-svg-icons/faCopy";
import { formatDateDot } from '../utils/dateFormatter';

const Header = ({ setEvent, social_urls , isAuthenticated}) => {
  const [event, setEventState] = useState({});
  const [QR_src, setQrSrc] = useState("");
  const [loadingEid, setLoadingEid] = useState(false);
  const { id_name } = useParams();
  const location = useLocation(); // Get the current location
  const [isModalOpen, setModalOpen] = useState(false);

  // Check if the current route contains "admin"
  const isAdminRoute = location.pathname.includes("admin");

  const updateEvent = (eventData) => {
    setEvent(eventData); // Update the parent state
    setEventState(eventData); // Update the local state
  };

  const fetchEventName = async () => {
    try {
      setLoadingEid(true);
      // Use the environment variable here
      const response = await api.get(
        process.env.REACT_APP_MODEL_ENDPOINT + `/check_eid?id_name=${id_name}`
      );

      if (response.data && response.data.success) {
        updateEvent(response.data.event);

        /** Create click log */
        api.post(
          `click/${response.data.event.event_id}`
          // No body needed; backend extracts headers and IP
        );

      } else {
        console.error("invalid event id:", response.data);
        updateEvent(false);
      }
    } catch (error) {
      updateEvent(false);
    } finally {
      setLoadingEid(false);
    }
  };

  useEffect(() => {
    document.title = event?.name ? event.name : "Pic-loud";

    if (event.event_id) {
      setQrSrc(
        `${process.env.REACT_APP_MODEL_ENDPOINT}/qr?eid=${event.event_id}`
      );
    } 

  }, [event]);


  useEffect(() => {
    fetchEventName();

  }, [id_name]);
  return (
    <>
      <div className="">
        {loadingEid ? (
          ""
        ) : event ? (
          // company logo and name
          <>          
      <Navbar bg="light" expand="lg" className="mb-2 border-bottom shadow-sm py-2">
          <Container fluid className="d-flex justify-content-between align-items-center">
        
            {/* company logo at the left corner */}
            <div className="me-auto align-items-center">
              {/* logo */}
              <Image src={`${process.env.REACT_APP_MODEL_ENDPOINT}/user_logo?user_id=${event.user?.user_id}` || "/logo_horizontal.png"} alt="Logo" height="40" />

              {/* name */}
              <span className="mx-2">
                <strong>{event.company_name || ""}</strong>
                {isAdminRoute && <small> Admin</small>}
              </span>
            </div>
            {/* Events infos: center */}

            <div className="ms-auto d-flex">
              {/* Social Media Links */}
              <SocialMedia social_urls={social_urls} color="text-dark" />
              {/* QR code btn logo */}
                  <button
                className="btn"
                onClick={() => setModalOpen(true)}
              >
                {/* font awsome QR code */}
                <FontAwesomeIcon icon={faShareNodes} size="1x" />
                </button>
                
            </div>
            </Container>
          </Navbar>
                     <div className="text-center d-flex justify-content-center align-items-center flex-column py-2 rounded">
        {/* <h3 className="fw-bold" style={{ fontFamily: "'Playfair Display', serif", fontSize: "2rem" }}> */}
        <h3
            className="fade-in"
            style={{
              fontFamily: "'Dancing Script', cursive",
              fontSize: "2.8rem",
              // color: "#8B005D",
              textShadow: "1px 1px 2px rgba(0, 0, 0, 0.1)"
            }}
          >
            {event.name}
          </h3>
        {event.date || event.location ? (
          <div className="d-flex justify-content-center gap-2 text-muted"
          style={{
            fontFamily: "'Dancing Script', cursive"
          }}
          > 
            {/* format date: DD.MM.YYYY */}
            <small>
              {event.date
                ? formatDateDot(event.date)
                : ""}
            </small>          
            {event.location && <small>| {event.location}</small>}
          </div>
        ) : null}
      </div>

          </>

        ) : (
          <h2 className="text-center">
            <img src="/logo_horizontal.png" alt="Pic-loud" style={{ width: "auto", height: "25px" }}/>
            </h2>
        )}
      </div>


      <div className="d-flex flex-column align-items-center justify-content-center">
          <Modal
            isOpen={isModalOpen}
            onClose={() => setModalOpen(false)}
            title="Share this event with your friends!"
          >
            <div className="text-center">
              {/* QR code */}
              {event.event_id && 
                <div>
                  <img
                    src={QR_src}
                    alt="QR Code"
                    style={{ width: "100%" }}
                    />
                  </div>
                }
                {/* Copy window location url icon */}
                <div>
                  <button
                    id="copy-url"
                    className="btn btn-light shadow-sm"
                    onClick={() => {
                      navigator.clipboard.writeText(window.location.href);
                      // turn to primary the button class (Jquery)
                      let elem = document.getElementById("copy-url");
                      elem.classList.remove("btn-light");
                      elem.classList.add("btn-success");
                      elem.innerHTML = "Copied!";
                    }}>
                    <span className="me-2">
                    Copy URL 
                      </span>           
                    {/* // font awsome copy icon */}
                    <FontAwesomeIcon icon={faCopy} size="1x" />
                  </button>
                </div>
            </div>
          </Modal>
        </div>

    </>
  );
};

export default Header;
